const setScrollbarWidth = () => {
  const cssVariableName = '--uu-scrollbar-width';
  const prevWidth = window
    .getComputedStyle(document.documentElement)
    .getPropertyValue(cssVariableName);
  const newWidth = `${window.innerWidth - document.body.clientWidth}px`;

  if (newWidth !== prevWidth) {
    document.documentElement.style.setProperty(cssVariableName, newWidth);
  }
};

export default setScrollbarWidth;